/**
 *
 * GroupTable
 *
 */

import * as React from 'react';

import { Group } from './types';
import { Table } from 'antd';
import { convertPermissionsToPermissionGroups } from 'utils/permissionMap';
import messages from './messages';
import styled from 'styled-components';
import translations from 'translations';

// import styled from 'styles/styled-components';

interface OwnProps {
  groups: Group[];
  loading: boolean;
  onGotoGroupDetails: (data) => void;
}

const Container = styled.div`
  border-radius: 4px;
  box-shadow: 4px 4px 8px rgba(4, 15, 15, 0.12);
  .ant-table tbody tr {
    cursor: pointer;
  }
  .ant-table-thead > tr > th {
    background: #f6ffed;
  }
  tbody {
    background-color: white;
  }
`;

const Text = styled.span`
  font-weight: 300;
`;

const columns = [
  {
    title: translations(messages.groups),
    key: 'name',
    dataIndex: 'name',
    width: 180,
  },
  {
    title: `# ${translations(messages.members)}`,
    key: 'groups',
    render: (group) => <Text>{group.members.length}</Text>,
    width: 180,
  },
  {
    title: translations(messages.permissions),
    key: 'permissions',
    width: 500,
    render: (group) => {
      const permissions = group.permissions.map((permission) => permission.action);
      const permissionGroup = convertPermissionsToPermissionGroups(permissions);
      return <Text>{permissionGroup.map((permission) => permission.title).join(', ')}</Text>;
    },
  },
];

const GroupTable: React.SFC<OwnProps> = (props: OwnProps) => {
  return (
    <Container>
      <Table
        dataSource={props.groups}
        columns={columns}
        pagination={false}
        loading={!!props.loading}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => props.onGotoGroupDetails(record.groupId),
          };
        }}
        scroll={{ y: 'calc(100vh - 380px)', x: 940 }}
      />
    </Container>
  );
};

export default GroupTable;
